export default __webpack_public_path__ + "static/media/mb-logo.4afedd5d.png";